import type { CommandRunner } from "./useCommandRunner";
import type { SerializedGameQueue } from "./useSerializedGameQueue";

export type RunCommand = CommandRunner["run"];
export type EnqueueCommand = SerializedGameQueue["enqueue"];

export function responseData(response: unknown): Record<string, unknown> {
  if (typeof response !== "object" || response === null) return {};
  const data = (response as { data?: unknown }).data;
  return typeof data === "object" && data !== null
    ? (data as Record<string, unknown>)
    : {};
}

export function responseRevision(response: unknown): number | null {
  const revision = responseData(response).committedRevision;
  return Number.isInteger(revision) ? (revision as number) : null;
}
